import { Table, Space, Button, Row, Col, Input, Select, Tooltip, notification, Modal, Pagination } from "antd";
import { SearchOutlined, SendOutlined, FilePdfOutlined, DeleteOutlined, } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { dropdownService, invoiceReceiptService } from "../../../../../services";
import { handlePDFDownload, handlePrint, exportToExcel } from "../../../../../utils/printing"
import { useDebounce } from "../../../../../hooks/useDebounce";
import { changeDocumentTitle } from "../../../../../utils/title";

function ReceiptCollect() {
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [mailLoading, setMailLoading] = useState(false);
  const [receipts, setReceipts] = useState([]);
  const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);
  const [isModalshow, setIsModalShow] = useState(false);
  const [allreceipts, setAllReceipts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [search, setSearch] = useState(null)
  const debouncedSearch = useDebounce(search, 500);
  const componentRef = useRef();

  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];

  const columns = [
    {
      title: "SAV",
      dataIndex: "SAV",
      key: "SAV",
      render: (text, record, index) =>
        ((pagination.current - 1) * pagination.pageSize + index + 1).toString().padStart(5, "0"),
    },
    {
      title: "Receipt Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Receipt Ref Number",
      dataIndex: "reference_number",
      key: "reference_number",
    },
    {
      title: "Reciept Date",
      dataIndex: "receipt_date",
      key: "receipt_date",
    },
    {
      title: "Payment Date",
      dataIndex: "payment_date",
      key: "payment_date",
    },
    {
      title: "Mode of Payment",
      dataIndex: "payment_mode",
      key: "payment_mode",
    },

    {
      title: "Customer",
      dataIndex: "user_id",
      key: "user_id",
      render: (text) => customers?.find((customer) => (customer.id === text))?.name
    },
    {
      title: "Action",
      key: "Action",
      className: "no-print",
      render: (text, record, { _id }) => (
        <Space size="small">
          <Tooltip title='Send'>
            {/* <Button type="primary" size="small" loading={mailLoading} onClick={() => handleMail(record.id)}> */}
            <SendOutlined loading={mailLoading} onClick={() => handleMail(record.id)} />
            {/* </Button> */}
          </Tooltip>

          <Tooltip title='Pdf'>
            <Link to={`/accounts/receipt-collects/PDF/${record.id}`}>
              {/* <Button type="primary" size="small"> */}
              <FilePdfOutlined style={{ fontSize: 12 }} />
              {/* </Button> */}
            </Link>
          </Tooltip>

          <Tooltip title='Delete'>
            {/* <Button type="primary" size="small"  > */}
            <DeleteOutlined onClick={() => showModal(record)} />
            {/* </Button> */}
          </Tooltip>
        </Space>
      ),
    },
  ];

  const showModal = (record) => {
    setSelectedDeleteRecord(record);
    setIsModalShow(true);
  };

  const handleCancel = () => {
    setIsModalShow(false);
    setSelectedDeleteRecord(null);
  };

  const handleDelete = async () => {
    if (!selectedDeleteRecord || !selectedDeleteRecord.id) {
      console.error("No entry selected for deletion.");
      return;
    }
    setDeleteLoading(true)
    const response = await invoiceReceiptService.delete(selectedDeleteRecord.id);
    setDeleteLoading(false)
    if (response.success) {
      notification.success({
        message: "Delete Successfully!",
        description: response.message,
        placement: "topRight",
      });
      initialize(pagination.current, pagination.pageSize, search);
    } else {
      console.error("Failed to delete the Receipt.");
    }
    setIsModalShow(false);
  };

  const handleMail = async (id) => {
    setMailLoading(true)
    const data = {
      receiptId: id
    }
    const response = await invoiceReceiptService.sendMail(data)
    setMailLoading(false)
    if (response.success) {
      notification.success({ message: "Mail Sent Successfully!" })
    }
  }

  const getAll = async () => {
    const response = await invoiceReceiptService.fetch(1, 10, true)
    if (response.success) {
      const mappedReceipts = response.data.map(receipt => {
        const customer = customers.find(c => c.id === receipt.user_id);
        return {
          ...receipt,
          user_id: customer ? customer.name : "Unknown",
        };
      });

      setAllReceipts(mappedReceipts)
    }
  }

  const getCustomers = async () => {
    const response = await dropdownService.fetchCustomers();
    if (response.success) {
      setCustomers(response.data);
    }
  }

  const initialize = async (page = 1, pageSize = pagination.current) => {
    setLoading(true);
    const { success, data } = await invoiceReceiptService.fetch(page, pageSize, false, debouncedSearch);
    if (success) {
      setReceipts(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
    setLoading(false);
  };



  useEffect(() => {
    changeDocumentTitle("Invoice Receipt");
    getCustomers();
    getAll();
  }, []);

  useEffect(() => {
    initialize(pagination.current, pagination.pageSize);

  }, [debouncedSearch])

  return (
    <div
      style={{ padding: "5px", border: "1px solid #ccc", borderRadius: "8px" }}
    >
      <Row gutter={16}>
        <Col span={12}>
          <h1 style={{ fontWeight: "bold", padding: "10px" }}>Receipt/Collection</h1>
        </Col>
      </Row>
      {/* <Divider style={{ marginTop: 15 }} /> */}
      <div style={{ background: "#F2F2F7" }} className="flex justify-end">
        <Link to={"/accounts/receipt-collects/add"}>
          <Button type="primary" style={{ padding: "4px", margin: "0 5px 0 5px" }}>
            Add Receipt
          </Button>
        </Link>
      </div>

      <div
        style={{ background: "#F2F2F7" }}
        className="flex justify-between mt-2 items-center"
      >

        <div className="flex">
          <Button
            onClick={() => handlePrint(allreceipts, columns, "Invoice Receipts Report")}
            type="primary"
            size="small"
            style={{ padding: "4px", margin: "0 5px 0 5px" }}
          >
            <span style={{ fontWeight: "bold", padding: "3px" }}>Print</span>
          </Button>


          <Button
            onClick={() => exportToExcel(allreceipts, "Invoice_receipts.xlsx")}
            type="primary"
            size="small"
            style={{ padding: "4px", margin: "0 5px 0 5px" }}
          >
            <span style={{ fontWeight: "bold", padding: "3px" }}>Excel</span>
          </Button>

          <Button
            onClick={() => handlePDFDownload(allreceipts, columns, "invoice Receipts Report", false)}
            type="primary"
            size="small"
            style={{ padding: "4px", margin: "0 5px 0 5px" }}
          >
            <span style={{ fontWeight: "bold", padding: "3px" }}>PDF</span>
          </Button>

        </div>

        <div className="flex justify-end w-full">
          <Input
            placeholder="Search ref number, customer & invoice"
            prefix={<SearchOutlined />}
            style={{
              width: "45%",
              borderRadius: "20px",
              fontSize: 14,
              margin: 10
            }}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <div id="printable-table">
        <Table
          ref={componentRef}
          columns={columns}
          scroll={{ x: "max-content" }}
          dataSource={receipts}
          rowKey="id"
          // pagination={{
          //   current: pagination.current,
          //   total: pagination.total,
          //   pageSize: pagination.pageSize,
          //   onChange: (page) => initialize(page, pagination.pageSize, search),
          //   showSizeChanger: false,
          // }}
          loading={loading}
          pagination={false}
          style={{ marginTop: "10px" }}
          footer={() => (
            <div className="flex justify-between items-center text-xs ">
              <div className=" text-gray-600">
                Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
                {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
                {pagination.total} entries
              </div>
              <Pagination
                current={pagination.current}
                total={pagination.total}
                pageSize={pagination.pageSize}
                showSizeChanger={false}
                onChange={(page) => initialize(page, pagination.pageSize, search)}
                itemRender={(current, type, originalElement) => {
                  if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                  if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                  return originalElement;
                }}
              />
            </div>
          )}
        />
      </div>

      {/* delete modal */}
      <Modal
        title={<div style={{ textAlign: "center" }}>Confirm</div>}
        open={isModalshow}
        onOk={handleDelete}
        onCancel={handleCancel}
        centered
        styles={{
          body: {
            padding: "20px",
          },
        }}
        width={300}
        footer={
          <div className="flex justify-center gap-3">
            <Button
              type="default"
              onClick={handleCancel}
              style={{ width: "30%" }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleDelete}
              loading={deleteLoading}
              style={{ width: "30%" }}
            >
              Confirm
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: "center" }}>
          Are you sure you want to delete this?
        </p>
      </Modal>
    </div>
  );
}
export default ReceiptCollect;
